Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var coreComponentsBaseModal = require('../../../base-modal');
var coreComponentsNavigationBarPrivate = require('../../../navigation-bar-private');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"headerWrapper":"bottom-sheet__headerWrapper_1bixv","hasContent":"bottom-sheet__hasContent_1bixv","header":"bottom-sheet__header_1bixv","sticky":"bottom-sheet__sticky_1bixv","highlighted":"bottom-sheet__highlighted_1bixv","justifyEnd":"bottom-sheet__justifyEnd_1bixv","addon":"bottom-sheet__addon_1bixv","addonFixed":"bottom-sheet__addonFixed_1bixv","title":"bottom-sheet__title_1bixv","titleCenter":"bottom-sheet__titleCenter_1bixv","titleLeft":"bottom-sheet__titleLeft_1bixv","trimTitle":"bottom-sheet__trimTitle_1bixv"};
require('./index.css');

var Header = function (_a) {
    var _b;
    var className = _a.className, sticky = _a.sticky, headerRef = _a.headerRef, headerOffset = _a.headerOffset, title = _a.title, children = _a.children, restProps = tslib.__rest(_a, ["className", "sticky", "headerRef", "headerOffset", "title", "children"]);
    var _c = React.useContext(coreComponentsBaseModal.BaseModalContext), setHeaderOffset = _c.setHeaderOffset, setHasHeader = _c.setHasHeader, headerHighlighted = _c.headerHighlighted, onClose = _c.onClose;
    React.useEffect(function () {
        setHeaderOffset(headerOffset);
    }, [headerOffset, setHeaderOffset]);
    React.useEffect(function () {
        setHasHeader(true);
    }, [setHasHeader]);
    var hasContent = Boolean(title || children);
    return (React__default.default.createElement(coreComponentsNavigationBarPrivate.NavigationBarPrivate, tslib.__assign({}, restProps, { ref: headerRef, title: title, onClose: onClose, sticky: sticky, view: 'mobile', className: cn__default.default(styles.headerWrapper, className, (_b = {},
            _b[styles.highlighted] = hasContent && headerHighlighted && sticky,
            _b[styles.sticky] = sticky,
            _b[styles.hasContent] = hasContent,
            _b)), contentClassName: cn__default.default(styles.title) }), children));
};

exports.Header = Header;
